import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row text-center items-center ellipsis sfx-priority-label" }

import { Icons } from "src/util/enums/fontAwesomeIcons"
import { numberToPriorityClass } from "src/util/functions/misc"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxPriorityLabel',
  props: {
  priorityNumber: {
    type: Number,
    required: true,
  },

  label: {
    type: String,
    required: true,
  },

  issueCount: {
    type: Number,
  },

  labelClass: {
    type: String,
  },

  issue: {
    type: Boolean,
    default: false,
  },

  chart: {
    type: Boolean,
    default: false,
  },

  iconSize: {
    type: String,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const iconName = computed(() => {
  if (props.issue) {
    return Icons.ISSUE
  } else if (props.chart) {
    return Icons.ISSUE_SOLID
  } else {
    return Icons.WORK_ORDERS
  }
})

const iconColor = computed(() => numberToPriorityClass(props.priorityNumber))

const iconSize = computed(() => props.iconSize || "24px")
const labelClass = computed(() => props.labelClass)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_icon, {
      name: iconName.value,
      color: iconColor.value,
      size: iconSize.value
    }, null, 8, ["name", "color", "size"]),
    _createElementVNode("div", {
      class: _normalizeClass(["q-pl-sm text-navy-700 text-bold text-center justify-center ellipsis", labelClass.value])
    }, _toDisplayString(props.priorityNumber) + "-" + _toDisplayString(props.label), 3),
    (props.issueCount !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["q-px-sm text-bold text-center justify-center text-fun-label-and-icon", labelClass.value])
        }, _toDisplayString(props.issueCount), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})